/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SSRV2RuleState
 */
export interface SSRV2RuleState {
    /**
     * 
     * @type {string}
     * @memberof SSRV2RuleState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SSRV2RuleState
     */
    disabled?: boolean;
}

export function SSRV2RuleStateFromJSON(json: any): SSRV2RuleState {
    return SSRV2RuleStateFromJSONTyped(json, false);
}

export function SSRV2RuleStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SSRV2RuleStateToJSON(value?: SSRV2RuleState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


